/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Index_TitleInputs */

const en_faq_index_title = /** @type {(inputs: Faq_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to a topic`)
};

const lv_faq_index_title = /** @type {(inputs: Faq_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pāriet uz tēmu`)
};

/**
* | output |
* | --- |
* | "Jump to a topic" |
*
* @param {Faq_Index_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_index_title = /** @type {((inputs?: Faq_Index_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Index_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_index_title(inputs)
	return en_faq_index_title(inputs)
});